import Vue from "vue";
import App from "./App";
import ElementUI from "element-ui";
import "element-ui/lib/theme-chalk/index.css";
import "@/assets/css/style.css";
import store from "./vuex/store";
import Vuex from "vuex";
import router from "@/router";
import myFilter from "@/filters/index.js";
import * as load from "@/utils/loading.js";
import { getCookie } from "@/utils/util.js";
import "font-awesome/css/font-awesome.min.css";
import { i18nManager } from "@/utils/i18n";
import backendMessages from './utils/i18n-messages.json';
import locale from 'element-ui/lib/locale/lang/zh-TW';


// 处理消息的多语言查找
function getLocalizedBackMessage(message) {
  // 如果message不是字符串，直接返回
  if (typeof message !== 'string') {
    return message;
  }
  
  // 动态获取当前语言
  const currentLang = localStorage.getItem('language') || 'zh-TW';
  
  // 如果前端i18n没有找到，查找后端错误码
  const backendLang = currentLang === 'zh-CN' ? 'zh_CN' : currentLang === 'zh-TW' ? 'zh_TW' : 'en';
  const backendLangConfig = backendMessages[backendLang] || backendMessages['zh_CN'];
  
  if (backendLangConfig && backendLangConfig[message]) {
    return backendLangConfig[message];
  }
  
  // 如果都没有找到，返回原message
  return message;
}

// 获取pagination的多语言文本
function getPaginationText() {
  const currentLang = localStorage.getItem('language') || 'zh-TW';
  
  const langConfig = {
    'zh-CN': {
      total: '共 {total} 条',
      sizes: '条/页',
      prev: '上一页',
      next: '下一页',
      jumper: '前往',
      page: '页'
    },
    'zh-TW': {
      total: '共 {total} 條',
      sizes: '條/頁',
      prev: '上一頁',
      next: '下一頁',
      jumper: '前往',
      page: '頁'
    },
    'en': {
      total: 'Total {total} items',
      sizes: 'items/page',
      prev: 'Previous',
      next: 'Next',
      jumper: 'Go to',
      page: 'page'
    }
  };
  
  return langConfig[currentLang] || langConfig['zh-TW'];
}

// 获取Element UI的locale配置
function getElementUILocale() {
  const currentLang = localStorage.getItem('language') || 'zh-TW';
  
  if (currentLang === 'zh-CN') {
    return require('element-ui/lib/locale/lang/zh-CN').default;
  } else if (currentLang === 'en') {
    return require('element-ui/lib/locale/lang/en').default;
  } else {
    return require('element-ui/lib/locale/lang/zh-TW').default;
  }
}

// 配置Element UI
Vue.use(ElementUI, {
  locale: getElementUILocale()
});



// 添加全局方法用于更新Element UI的locale
Vue.prototype.$updateElementUILocale = function(language) {
  const langConfig = {
    'zh-CN': {
      total: '共 {total} 条',
      sizes: '条/页',
      prev: '上一页',
      next: '下一页',
      jumper: '前往',
      page: '页'
    },
    'zh-TW': {
      total: '共 {total} 條',
      sizes: '條/頁',
      prev: '上一頁',
      next: '下一頁',
      jumper: '前往',
      page: '頁'
    },
    'en': {
      total: 'Total {total} items',
      sizes: 'items/page',
      prev: 'Previous',
      next: 'Next',
      jumper: 'Go to',
      page: 'page'
    }
  };
  
  const config = langConfig[language] || langConfig['zh-TW'];
  
  // 更新Element UI的全局locale配置
  if (Vue.prototype.$ELEMENT) {
    Vue.prototype.$ELEMENT.locale = {
      el: {
        pagination: {
          goto: config.jumper,
          pagesize: config.sizes,
          total: config.total,
          pageClassifier: config.page
        }
      }
    };
  }
  
  // 强制更新所有分页组件
  this.$nextTick(() => {
    const paginationComponents = document.querySelectorAll('.el-pagination');
    paginationComponents.forEach(component => {
      const vueInstance = component.__vue__;
      if (vueInstance) {
        vueInstance.$forceUpdate();
      }
    });
  });
  
  // 触发全局事件，通知所有组件更新
  this.$root.$emit('element-ui-locale-updated', language);
};

// 添加全局强制更新所有组件的方法
Vue.prototype.$forceUpdateAllComponents = function() {
  // 强制更新根实例
  if (this.$root) {
    this.$root.$forceUpdate();
  }
  
  // 递归更新所有子组件
  const updateAllChildren = (component) => {
    if (component.$children && component.$children.length > 0) {
      component.$children.forEach(child => {
        if (child.$forceUpdate) {
          child.$forceUpdate();
          updateAllChildren(child);
        }
      });
    }
  };
  
  updateAllChildren(this.$root);
};
Vue.use(Vuex);

Vue.prototype.$load = load;
Vue.prototype.$i18n = i18nManager;

// 重写 $message 方法，支持多语言
const originalMessage = Vue.prototype.$message;
Vue.prototype.$message = function(options) {
  console.log("$message", options)
  if (typeof options === 'string') {
    // 如果传入的是字符串，转换为对象格式
    options = {
      message: options,
      type: 'info'
    };
  }
  
  // 处理消息的多语言
  if (options.message) {
    options.message = getLocalizedBackMessage(options.message);
  }
  
  // 调用原始的 $message 方法
  return originalMessage.call(this, options);
};

// 保留 Element UI 的便捷方法
Vue.prototype.$message.success = function(message) {
  return originalMessage.call(this, {
    message: getLocalizedBackMessage(message),
    type: 'success'
  });
};

Vue.prototype.$message.warning = function(message) {
  return originalMessage.call(this, {
    message: getLocalizedBackMessage(message),
    type: 'warning'
  });
};

Vue.prototype.$message.info = function(message) {
  return originalMessage.call(this, {
    message: getLocalizedBackMessage(message),
    type: 'info'
  });
};

Vue.prototype.$message.error = function(message) {
  return originalMessage.call(this, {
    message: getLocalizedBackMessage(message),
    type: 'error'
  });
};

Vue.prototype.$message.msg = function(message) {
  return originalMessage.call(this, {
    message: getLocalizedBackMessage(message),
    type: 'info'
  });
};


Vue.prototype.$message.closeAll = function() {
  originalMessage.closeAll();
};


for (let key in myFilter) {
  Vue.filter(key, myFilter[key]);
}

router.beforeEach((to, from, next) => {
  if (to.path == "/login") {
    sessionStorage.removeItem("user");
  }
  let token = getCookie("token");
  if (token === "" && to.path != "/login") {
    next({ path: "/login" });
  } else {
    next();
  }
});

new Vue({
  router,
  store,
  render: (h) => h(App),
}).$mount("#app");



// WEBPACK FOOTER //
// ./src/main.js